import React, { Component } from 'react';
import styles from './Button.module.css';

class Button extends Component {

  checkStyle(){
    let className = this.props.noRipple ? '' : styles.ripple + ' ';
    if(this.props.disabled){
      className += styles.disabled + ' ';
    }
    if(this.props.className){
      className += this.props.className + ' ';
    }
    if(this.props.styleType){
      className += styles[this.props.styleType];
    }else{
      className += styles.default;
    }

    return className;
  }

  render() {
    return (
      <button type="button" disabled={this.props.disabled} onClick={this.props.onClick} className={this.checkStyle()}>
        {this.props.children}
      </button>
    );
  }

}

export default Button;